@if (open) {
  <div
    class="tfr-modal-overlay"
    role="presentation"
    (click)="onBackdropClick()">
    <div
      class="tfr-modal-panel max-w-md"
      role="dialog"
      aria-modal="true"
      aria-labelledby="crm-lead-onboarding-title"
      (click)="$event.stopPropagation()">

      <div class="flex items-start justify-between gap-3 mb-4">
        <div>
          <h2 id="crm-lead-onboarding-title" class="text-[15px] font-bold tracking-tight text-midnight-indigo">
            Nuevo lead
          </h2>
          <p class="mt-1 text-[12px] text-steel-gray leading-relaxed">
            Empieza por el local en Google Maps. Si el tel&eacute;fono ya existe, el local se a&ntilde;adir&aacute; al mismo contacto.
          </p>
        </div>
        <button
          type="button"
          (click)="cancelled.emit()"
          [disabled]="loading()"
          class="h-8 w-8 shrink-0 flex items-center justify-center rounded-lg text-steel-gray
                 hover:text-slate-blue hover:bg-pale-gray transition-colors disabled:opacity-40"
          aria-label="Cerrar">
          <lucide-icon name="x" class="h-4 w-4" />
        </button>
      </div>

      @if (phase() === 'choose') {
        <div class="flex flex-col gap-3">
          <button
            type="button"
            (click)="pickImport()"
            class="w-full text-left rounded-xl border border-pale-gray bg-cloud-mist px-4 py-4
                   transition-colors hover:border-slate-blue/30 hover:bg-snow-white">
            <div class="flex items-start gap-3">
              <span class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-snow-white border border-pale-gray">
                <lucide-icon name="map-pin" class="h-4 w-4 text-slate-blue" />
              </span>
              <div>
                <p class="text-[13px] font-semibold text-midnight-indigo">Importar desde Google Maps</p>
                <p class="mt-1 text-[11px] text-steel-gray leading-snug">
                  Nombre del local, direcci&oacute;n, tel&eacute;fono y web.
                </p>
              </div>
            </div>
          </button>

          <button
            type="button"
            (click)="pickManual()"
            class="w-full text-left rounded-xl border border-pale-gray px-4 py-4
                   transition-colors hover:border-slate-blue/30 hover:bg-cloud-mist">
            <div class="flex items-start gap-3">
              <span class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-cloud-mist border border-pale-gray">
                <lucide-icon name="pencil" class="h-4 w-4 text-steel-gray" />
              </span>
              <div>
                <p class="text-[13px] font-semibold text-midnight-indigo">A&ntilde;adir a mano</p>
                <p class="mt-1 text-[11px] text-steel-gray leading-snug">
                  Introduce contacto y local manualmente en la ficha.
                </p>
              </div>
            </div>
          </button>
        </div>
      } @else {
        <div class="flex flex-col gap-3">
          <button
            type="button"
            (click)="backToChoose()"
            [disabled]="loading()"
            class="self-start text-[11px] font-medium text-steel-gray hover:text-slate-blue disabled:opacity-40">
            &larr; Volver
          </button>

          <label class="tfr-field-label" for="crm-onboarding-maps-url">
            Enlace de Google Maps
          </label>
          <input
            id="crm-onboarding-maps-url"
            type="url"
            class="tfr-input"
            [class.tfr-input--invalid]="error()"
            placeholder="https://maps.app.goo.gl/..."
            [ngModel]="mapsUrl()"
            (ngModelChange)="mapsUrl.set($event); error.set(null)"
            [disabled]="loading()" />

          @if (loading()) {
            <div
              class="rounded-xl border border-pale-gray bg-cloud-mist px-3.5 py-3 flex gap-3 items-start"
              role="status"
              aria-live="polite">
              <lucide-icon name="loader-circle" class="h-4 w-4 shrink-0 animate-spin text-slate-blue mt-0.5" />
              <div class="min-w-0">
                <p class="text-[12px] font-medium text-midnight-indigo">
                  Extrayendo datos del local&hellip;
                </p>
                <p class="text-[11px] text-steel-gray mt-0.5 leading-snug">{{ loadingHint() }}</p>
              </div>
            </div>
          } @else if (error(); as err) {
            <p class="text-[11px] text-slate-blue leading-snug">{{ err }}</p>
          } @else {
            <p class="text-[11px] text-steel-gray">
              En Maps: Compartir &rarr; copiar enlace del local.
            </p>
          }

          <button
            type="button"
            (click)="submitImport()"
            [disabled]="loading() || !urlLooksValid()"
            class="tfr-btn-dark w-full mt-1 disabled:opacity-40">
            @if (loading()) {
              Importando&hellip;
            } @else {
              Continuar
            }
          </button>
        </div>
      }
    </div>
  </div>
}
